module.exports = __webpack_public_path__ + "img/c2m_coop2.2f0218a8.png";